import { CloseOutlined } from "@mui/icons-material";
import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    TextField,
    Typography,
    Box,
} from "@mui/material";
import React, { useState } from "react";
import { apiGatewayAxiosInstance } from "../../utils/axios";
import { ERoles } from "../../config";
import useAuth from "../../hooks/useAuth";

function RechargeModal({ open, handleClose, currentData, getMasterBillingDetails, setOperationStatus }) {
    const [recharge, setRecharge] = useState(0);
    const [description, setDescription] = useState("");
    const [loading, setLoading] = useState(false);
    const { user } = useAuth();
    const [error, setError] = useState(false);

    const handleChange = event => {
        const rawValue = event.target.value;

        if (rawValue === "") {
            setRecharge(null);
            setError(false);
            return;
        }

        const value = Number(rawValue);

        if (isNaN(value) || value < 0) {
            setError(true);
            return;
        }

        if (value > 10000000) {
            return;
        }

        setError(false);
        setRecharge(value);
    };

    const handleBlur = () => {
        if (recharge > 10000000) {
            setRecharge(10000000);
            setError(false);
        }
    };

    const updateCurrentBalance = async (recharge, description) => {
        setLoading(true);
        const updatedBillingData = { ...currentData };
        updatedBillingData.recharge = Number(recharge);
        updatedBillingData.description = description;

        const payload = { ...updatedBillingData, resellerName: updatedBillingData.data.resellerName, orgName: updatedBillingData.data.orgName };
        if (user?.roleName.toLowerCase() === ERoles.SUPER_ADMIN) {
            payload.roleName = ERoles.RESELLER_ADMIN;
        }
        if (user?.roleName.toLowerCase() === ERoles.RESELLER_ADMIN) {
            payload.roleName = ERoles.ORG_ADMIN;
        }
        delete payload.data;
        try {
            const response = await apiGatewayAxiosInstance.post("/billing_management/current-billing/update-master-billing-details", payload);
            setOperationStatus({
                message: "Recharge Successful.",
                success: true,
                failed: false,
            });
            getMasterBillingDetails();
            handleClose();
            setLoading(false);
            return response;
        } catch (error) {
            console.error("Error updating balance:", error);
            setLoading(false);
            throw error;
        }
    };

    return (
        <Dialog open={open} onClose={handleClose} aria-labelledby="filter-dialog-title" maxWidth={"xs"} fullWidth>
            <DialogTitle
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <Typography variant="h5">Recharge {currentData?.data?.resellerName ?? currentData?.data?.orgName}</Typography>

                <IconButton onClick={handleClose}>
                    <CloseOutlined />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid>
                    <TextField
                        type="number"
                        name="recharge"
                        style={{ width: "100%" }}
                        className="field-spacing"
                        label="Recharge (INR)"
                        variant="outlined"
                        value={recharge ?? ""}
                        onChange={handleChange}
                        // onBlur={handleBlur}
                        error={error}
                        inputProps={{
                            min: 0,
                            max: 10000000,
                        }}
                    />
                    <Box mt={1}>
                        <Typography variant="caption" color="text.secondary">
                            Maximum allowed recharge is ₹1 Cr
                        </Typography>
                    </Box>
                </Grid>
                <Grid>
                    <TextField
                        type="text"
                        name="description"
                        style={{ width: "100%" }}
                        className="field-spacing"
                        label="Description"
                        variant="outlined"
                        multiline
                        rows={3}
                        value={description}
                        onChange={e => setDescription(e.target.value)}
                        inputProps={{
                            maxLength: 500,
                        }}
                    />
                    <React.Fragment>
                        <Box
                            sx={{
                                p: 1,
                                mx: 1,
                                fontSize: "0.875rem",
                                fontWeight: "700",
                                display: "flex",
                                flexDirection: "row-reverse",
                            }}
                        >
                            {`${description.length}`}
                            /500
                        </Box>
                    </React.Fragment>
                </Grid>

                <Grid container flexDirection={"row-reverse"} gap={2} paddingTop={2}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => updateCurrentBalance(recharge, description)}
                        disabled={error || !recharge || loading || Number(recharge) === 0 || recharge > 10000000}
                        startIcon={loading ? <CircularProgress size={24} color="inherit" /> : null}
                    >
                        {loading ? "Submitting..." : "Submit"}
                    </Button>

                    <Button variant="outlined" color="error" onClick={handleClose}>
                        Cancel
                    </Button>
                </Grid>
            </DialogContent>
        </Dialog>
    );
}

export default RechargeModal;
